module.exports = __webpack_public_path__ + "static/media/gicon-1.d0a85480.png";